import styles from "./styles.module.scss";
import {Button} from "@shopify/polaris";
import cn from "classnames";
import useTranslation from "next-translate/useTranslation";
import {useRouter} from "next/router";
import {signUtmParams} from "../../../helpers/signUtmParams";
import {APP_STORE_LINK} from "../../../utils/constants";

const ViewMore = () => {
  const {t, lang} = useTranslation("common");
  const router = useRouter();

  return (
    <section className={cn(styles["viewmore"], "viewmore", styles[`viewmore--${lang}`])}>
      <header className={styles["viewmore__header-wrapper"]}>
        <h3 className={styles["viewmore__header"]}>{t("viewmore.header")}</h3>
        <p className={styles["viewmore__subheader"]}>{t("viewmore.subheader")}</p>
      </header>
      <div className={styles["viewmore__link-wrapper"]}>
        <Button url={signUtmParams(APP_STORE_LINK, router)} external primary>{t("viewmore.link")} </Button>
        <div className={styles["viewmore__link-pointer"]}>{t("viewmore.pointer")}</div>
      </div>
    </section>
  );
};

export default ViewMore;